import { Outlet, Navigate } from 'react-router';
import { useSelector } from 'react-redux';

const CHIEF_ADMIN_EMAIL = process.env.REACT_APP_CHIEF_ADMIN_EMAIL;

export default function ChiefAdminRoute() {
  const { userInfo } = useSelector((state) => state.auth);

  return userInfo && userInfo.isAdmin && userInfo.primaryEmail === CHIEF_ADMIN_EMAIL ? (
    <Outlet />
  ) : (
    <Navigate to='/sign_in' replace />
  );
}
